/* MO Videotutorial - one controller for all product pages.
   Video markup stays inert inside <template> until the user clicks. */
(function () {
  'use strict';

  if (window.__moVideotutorialReady) return;
  window.__moVideotutorialReady = true;

  var dialog = null;
  var lastTrigger = null;

  function getDialog() {
    if (dialog && dialog.isConnected) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'mo-videotutorial-dialog';
    dialog.setAttribute('aria-label', 'Videotutorial del producto');
    dialog.innerHTML =
      '<button type="button" class="mo-videotutorial-dialog__close" aria-label="Cerrar videotutorial">&times;</button>' +
      '<div class="mo-videotutorial-dialog__media"></div>';

    document.body.appendChild(dialog);

    dialog.querySelector('.mo-videotutorial-dialog__close').addEventListener('click', function () {
      dialog.close();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', function () {
      var mediaContainer = dialog.querySelector('.mo-videotutorial-dialog__media');
      var video = mediaContainer.querySelector('video');

      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach(function (source) {
          source.removeAttribute('src');
        });
        video.load();
      }

      mediaContainer.replaceChildren();
      if (lastTrigger && lastTrigger.isConnected) {
        lastTrigger.focus({ preventScroll: true });
      }
    });

    return dialog;
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var button = event.target.closest('.mo-videotutorial__button');
    if (!button) return;

    event.preventDefault();

    var block = button.closest('.mo-videotutorial');
    var template = block && block.querySelector('template.mo-videotutorial__template');
    if (!template) return;

    var videoMarkup = template.content.cloneNode(true);
    var video = videoMarkup.querySelector('video');
    if (!video) return;

    var modal = getDialog();
    if (modal.open) return;

    var ratio = parseFloat(button.dataset.ratio);
    modal.classList.toggle('is-portrait', Number.isFinite(ratio) && ratio < 1);
    if (Number.isFinite(ratio) && ratio > 0) {
      video.style.aspectRatio = String(ratio);
    }

    video.controls = true;
    video.playsInline = true;
    video.preload = 'auto';

    modal.querySelector('.mo-videotutorial-dialog__media').replaceChildren(videoMarkup);
    lastTrigger = button;
    modal.showModal();

    var playResult = video.play();
    if (playResult && typeof playResult.catch === 'function') {
      playResult.catch(function () {
        // Native controls remain available if the browser blocks autoplay with sound.
      });
    }
  }, true);
})();
